import { CountryEntity } from 'api/types/entity';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import {
  CountryRiskBadges,
  CountryRiskField,
} from 'modules/client/common/feature';
import {
  Field,
  TaxResidencyFormTaxValue,
} from 'modules/client/common/forms/taxResidencyForm';

interface Props {
  index: number;
  value: TaxResidencyFormTaxValue;
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const Fields = ({
  index,
  value,
  countriesLoading,
  countries,
}: Props) => {
  const { t } = useTranslation();

  return (
    <GridFields>
      <Field.Autocomplete
        showRequiredMark
        label={t('client.client.taxResidency.country.label')}
        loading={countriesLoading}
        name={`taxResidences.${index}.country`}
        optionLabelKey="name"
        options={countries}
        optionValueKey="id"
        placeholder={t('client.client.taxResidency.country.placeholder')}
        renderOptionRightAdornment={(option) => <CountryRiskBadges
          country={option as CountryEntity}
          field={CountryRiskField.TaxResidence}
        />}
        rightStartElement={
          <CountryRiskBadges
            country={value.country}
            field={CountryRiskField.TaxResidence}
          />
        }
      />
      {value.taxNumberIsMissing ? (
        <Field.Text
          key="taxNumberIsMissing"
          fullWidth
          showRequiredMark
          label={t('client.client.taxResidency.reasonForAbsence.label')}
          name={`taxResidences.${index}.reasonForAbsence`}
          placeholder={t(
            'client.client.taxResidency.reasonForAbsence.placeholder'
          )}
        />
      ) : (
        <Field.Text
          key={`taxNumber-${index}`}
          fullWidth
          showRequiredMark
          label={t('client.client.taxResidency.taxNumber.label')}
          name={`taxResidences.${index}.taxNumber`}
          placeholder={t('client.client.taxResidency.taxNumber.placeholder')}
        />
      )}
    </GridFields>
  );
};
